import { useTranslator } from '@bluebeam/react-i18n';
import { ModalStaticProperties } from 'components/ModalPortal/ModalPortal';
import ModalStdHeader from 'components/modals/ModalStdHeader';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext, useEffect } from 'react';
import MapDrawingOption from './MapDrawingOption';
import MapDrawingSelectionSubHeader from './MapDrawingSelectionSubHeader';

const MapDrawingSelectionModal: React.FC & ModalStaticProperties = () => {
  const { state: appState, actions } = useContext(AppStoreContext);
  const { sheets } = appState;
  const sheetsLength = sheets.toList().size;
  const { translate } = useTranslator(['mapView']);

  useEffect(() => {
    actions.getSheets();
  }, []);
  return (
    <div id="map-drawing-selection-modal" className="modal__content pt3">
      <ModalStdHeader
        text={translate('mapView:mapDrawingSelection.selectDrawing')}
      />
      <div className="h100 px5 pt7 pb5">
        <MapDrawingSelectionSubHeader sheetsLength={sheetsLength} />
        <div className="b-2 oa">
          <div
            className="m3"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 170px)',
              gridTemplateRows: 'repeat(auto-fill, 175px)',
              gridGap: '16px',
              justifyContent: 'space-evenly',
              height: 'calc(100vh - 368px)',
            }}
          >
            {sheets.toList().map((sheet) => (
              <MapDrawingOption key={sheet.sheetid} sheet={sheet} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

MapDrawingSelectionModal.modalClasses = {
  overlay: `modal__overlay`,
  content: `modal__window modal--sm`,
};

MapDrawingSelectionModal.modalStyles = {
  content: {
    width: '628px',
  },
};
export default MapDrawingSelectionModal;
